import { gql } from 'graphql-request';
import {
  LifestyleAccentColorID,
  LifestyleAccentColorLocalizedName,
  LifestyleAssociatedMaterialID,
  LifestyleAuthorID,
  LifestyleAuthorLocalizedName,
  LifestyleBlocked,
  LifestyleCategoryID,
  LifestyleCategoryLocalizedName,
  LifestyleClientCurrentTeamNanoId,
  LifestyleClientFullName,
  LifestyleClientID,
  LifestyleClientNanoId,
  LifestyleCreatedAt,
  LifestyleCustomTagID,
  LifestyleCustomTagName,
  LifestyleCustomTagNameEn,
  LifestyleCustomTagUUID,
  LifestyleFavorite,
  LifestyleGammaID,
  LifestyleGammaLocalizedName,
  LifestyleID,
  LifestyleImageFile,
  LifestyleImageID,
  LifestyleImageName,
  LifestyleImageSize,
  LifestyleImageUUID,
  LifestyleLifestyleID,
  LifestyleLifestyleTypeID,
  LifestyleLifestyleTypeLocalizedName,
  LifestyleMainColorID,
  LifestyleMainColorLocalizedName,
  LifestyleMaterialID,
  LifestyleMaterialLocalizedName,
  LifestyleMaxFileFile,
  LifestyleMaxFileID,
  LifestyleMaxFileName,
  LifestyleMaxFileSize,
  LifestyleMaxFileUUID,
  LifestyleName,
  LifestyleNanoID,
  LifestyleNda,
  LifestylePremiumContentAt,
  LifestylePrice,
  LifestyleProductID,
  LifestyleProjectID,
  LifestyleProjectName,
  LifestyleProjectNameID,
  LifestyleProjectNameLocalizedName,
  LifestyleProjectNanoID,
  LifestyleRenderLocalizedName,
  LifestyleRenderTypeID,
  LifestyleStyleID,
  LifestyleStyleLocalizedName,
  LifestyleTagID,
  LifestyleTagLocalizedName,
  LifestyleTagNameEn,
  LifestyleTaskID,
  LifestyleTaskName,
  LifestyleTaskNanoID,
  LifestyleTeamID,
  LifestyleTeamName,
  LifestyleTeamNanoId,
  LifestyleTeamUUID,
  LifestyleToneID,
  LifestyleToneLocalizedName,
  LifestyleTrackedHours,
  LifestyleUUID
} from '../lifestylesTypes';

export interface CacheFetchShowLifestyleQueryResponseImage {
  id: LifestyleImageID;
  uuid: LifestyleImageUUID;
  file: LifestyleImageFile;
  size: LifestyleImageSize;
  name: LifestyleImageName;
}

export interface CacheFetchShowLifestyleQueryResponseMaxFile {
  id: LifestyleMaxFileID;
  uuid: LifestyleMaxFileUUID;
  file: LifestyleMaxFileFile;
  size: LifestyleMaxFileSize;
  name: LifestyleMaxFileName;
}

export interface CacheFetchShowLifestyleQueryResponse {
  id: LifestyleID;
  uuid: LifestyleUUID;
  nanoId: LifestyleNanoID;
  name: LifestyleName;
  nda: LifestyleNda;
  favorite: LifestyleFavorite;
  blocked: LifestyleBlocked;
  premiumContentAt: LifestylePremiumContentAt | null;
  price?: LifestylePrice;
  trackedHours?: LifestyleTrackedHours;
  image: CacheFetchShowLifestyleQueryResponseImage;
  images?: CacheFetchShowLifestyleQueryResponseImage[];
  maxFile: {
    createdAt: LifestyleCreatedAt;
  };
  maxFiles?: CacheFetchShowLifestyleQueryResponseMaxFile[];
  author?: {
    id: LifestyleAuthorID;
    localizedName: LifestyleAuthorLocalizedName;
  };
  clients: {
    id: LifestyleClientID;
    nanoId: LifestyleClientNanoId;
    fullName: LifestyleClientFullName;
    currentTeam: {
      nanoId: LifestyleClientCurrentTeamNanoId;
    };
  }[];
  teams: {
    id: LifestyleTeamID;
    nanoId: LifestyleTeamNanoId;
    uuid: LifestyleTeamUUID;
    name: LifestyleTeamName;
  }[];
  projectName?: {
    id: LifestyleProjectNameID;
    localizedName: LifestyleProjectNameLocalizedName;
  };
  project?: {
    id: LifestyleProjectID;
    nanoId: LifestyleProjectNanoID;
    name: LifestyleProjectName;
  };
  task?: {
    id: LifestyleTaskID;
    nanoId: LifestyleTaskNanoID;
    name: LifestyleTaskName;
  };
  category?: {
    id: LifestyleCategoryID;
    localizedName: LifestyleCategoryLocalizedName;
  };
  styles: {
    id: LifestyleStyleID;
    localizedName: LifestyleStyleLocalizedName;
  }[];
  tone?: {
    id: LifestyleToneID;
    localizedName: LifestyleToneLocalizedName;
  };
  gamma?: {
    id: LifestyleGammaID;
    localizedName: LifestyleGammaLocalizedName;
  };
  mainColors: {
    id: LifestyleMainColorID;
    localizedName: LifestyleMainColorLocalizedName;
  }[];
  accentColors: {
    id: LifestyleAccentColorID;
    localizedName: LifestyleAccentColorLocalizedName;
  }[];
  materials: {
    id: LifestyleMaterialID;
    localizedName: LifestyleMaterialLocalizedName;
  }[];
  tags: {
    id: LifestyleTagID;
    nameEn: LifestyleTagNameEn;
    localizedName: LifestyleTagLocalizedName;
  }[];
  lifestyleType?: {
    id: LifestyleLifestyleTypeID;
    localizedName: LifestyleLifestyleTypeLocalizedName;
  };
  renderTypes: {
    id: LifestyleRenderTypeID;
    localizedName: LifestyleRenderLocalizedName;
  }[];
  products: {
    id: LifestyleProductID;
  }[];
  lifestyles: {
    id: LifestyleLifestyleID;
  }[];
  customTags: {
    id: LifestyleCustomTagID;
    uuid: LifestyleCustomTagUUID;
    name: LifestyleCustomTagName;
    nameEn: LifestyleCustomTagNameEn;
  }[];
  associatedMaterials: {
    id: LifestyleAssociatedMaterialID;
  }[];
}

export const CACHE_FETCH_SHOW_LIFESTYLE_QUERY = gql`
  query CacheLifestyle($uuid: ID!, $source: String) {
    lifestyle(uuid: $uuid, source: $source) {
      id
      uuid
      nanoId
      name
      nda
      favorite
      blocked
      premiumContentAt
      #      price
      trackedHours
      image {
        id
        uuid
        file
        size
        name
      }
      images {
        id
        uuid
        file
        size
        name
      }
      maxFile {
        createdAt
      }
      maxFiles {
        id
        uuid
        file
        size
        name
      }
      author {
        id
        localizedName
      }
      clients {
        id
        nanoId
        fullName
        currentTeam {
          nanoId
        }
      }
      teams {
        id
        nanoId
        uuid
        name
      }
      projectName {
        id
        localizedName
      }
      project {
        id
        nanoId
        name
      }
      task {
        id
        nanoId
        name
      }
      category {
        id
        localizedName
      }
      styles {
        id
        localizedName
      }
      tone {
        id
        localizedName
      }
      gamma {
        id
        localizedName
      }
      mainColors {
        id
        localizedName
      }
      accentColors {
        id
        localizedName
      }
      materials {
        id
        localizedName
      }
      tags {
        id
        localizedName
        nameEn
      }
      lifestyleType {
        id
        localizedName
      }
      renderTypes {
        id
        localizedName
      }
      products {
        id
      }
      lifestyles {
        id
      }
      customTags {
        id
        uuid
        name
        nameEn
      }
      associatedMaterials {
        id
      }
    }
  }
`;
